import localStorage from 'local-storage-fallback';
import {
  SAVE_SESSION,
  CLEAR_SESSION,
  SAVE_LAST_DIGITS,
  SAVE_CLIENT_INFO,
  SAVE_CLIENT_TYPE,
  SAVE_CLIENT_MSISDN,
  SAVE_CPF, SAVE_SESSION_ID,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  token: localStorage.getItem('token'),
  sessionId: '',
  msisdn: '',
  cpf: '',
  lastDigits: '',
};

const saveSessionId = (state, action) => ({
  ...state,
  sessionId: action.id,
});

const saveSession = (state, action) => ({
  ...state,
  sessionId: action.id,
  msisdn: action.msisdn,
  cpf: action.cpf,
  channel: action.channel,
});

const saveMsisdn = (state, action) => ({
  ...state,
  msisdn: action.payload,
});

const applyClearSession = state => ({ ...state, token: null, msisdn: null });

const saveLastDigits = (state, action) => ({
  ...state,
  lastDigits: action.payload,
});

const saveClientInfo = (state, action) => ({
  ...state,
  clientInfo: action.payload,
});

const saveClientType = (state, action) => ({
  ...state,
  clientType: action.payload,
});

const saveCpf = (state, action) => ({
  ...state,
  cpf: action.payload,
});

const sessionReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SAVE_SESSION_ID:
      return saveSessionId(state, action);
    case SAVE_SESSION:
      return saveSession(state, action);
    case CLEAR_SESSION:
      return applyClearSession(state);
    case SAVE_LAST_DIGITS:
      return saveLastDigits(state, action);
    case SAVE_CLIENT_MSISDN:
      return saveMsisdn(state, action);
    case SAVE_CLIENT_INFO:
      return saveClientInfo(state, action);
    case SAVE_CLIENT_TYPE:
      return saveClientType(state, action);
    case SAVE_CPF:
      return saveCpf(state, action);
    default:
      return state;
  }
};

export default sessionReducer;
